// Pure formatters used across the UI. Keep dependency-free.

export function paiseToRupees(paise, { withSymbol = true } = {}) {
  if (paise === null || paise === undefined || paise === '') return '—';
  const n = Number(paise);
  if (!Number.isFinite(n)) return String(paise);
  const rupees = (n / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return withSymbol ? `₹ ${rupees}` : rupees;
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  });
}

export function shortId(id) {
  if (typeof id !== 'string' || id.length < 8) return id || '—';
  return `${id.slice(0, 8)}…`;
}

// Stage 5N-9A — trigger a browser download for a Blob received from
// the API. Used by invoice-PDF buttons. Cleans up the object URL on
// the next event-loop tick to avoid leaking the buffer.
export function downloadBlob(blob, filename) {
  if (!blob) return;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

// Stage 5N-9A — turn an axios error whose body is a Blob (responseType:
// 'blob') into the standard `{code, message}` envelope our APIs use.
// Returns null on unparseable bodies so the caller falls back to
// extractApiError().
export async function readBlobError(err) {
  const data = err && err.response && err.response.data;
  if (!data || typeof data.text !== 'function') return null;
  try {
    const text = await data.text();
    if (!text) return null;
    const parsed = JSON.parse(text);
    return parsed && parsed.error ? parsed.error : null;
  } catch (_e) {
    return null;
  }
}

// Stage 5N-9A — turn an axios error whose body is a raw string
// (responseType: 'text', e.g. the report-viewer endpoint) into the
// standard `{code, message}` envelope. Returns null on unparseable
// bodies so callers fall back to extractApiError().
export function readTextError(err) {
  const data = err && err.response && err.response.data;
  if (typeof data !== 'string' || data.length === 0) return null;
  try {
    const parsed = JSON.parse(data);
    return parsed && parsed.error ? parsed.error : null;
  } catch (_e) {
    return null;
  }
}

// Pull the most useful message out of an axios error.
export function extractApiError(err) {
  if (!err) return 'unknown error';
  const data = err.response && err.response.data;
  if (data && data.error) {
    const parts = [data.error.code, data.error.message].filter(Boolean);
    return parts.join(' — ') || 'request failed';
  }
  if (err.message) return err.message;
  return 'request failed';
}
